var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-summary-box" },
    [
      _vm.isLoading ? _c("loading-spinner") : _vm._e(),
      _vm._v(" "),
      _c(
        "ol",
        { staticClass: "c-summary-box__questions" },
        _vm._l(_vm.summary, function(question, index) {
          return question.answerLabel
            ? _c(
                "li",
                { key: question.id, staticClass: "c-summary-box__question" },
                [
                  _c("h3", { staticClass: "c-summary-box__question-text" }, [
                    _vm._v(_vm._s(question.label))
                  ]),
                  _vm._v(" "),
                  _c("h4", { staticClass: "c-summary-box__answer-text" }, [
                    _vm._v(_vm._s(question.answerLabel))
                  ])
                ]
              )
            : _vm._e()
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "c-summary-box__actions" },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f54cc748", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f54cc748","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/_contact-us-rap/_vue/SummaryBox.vue
// module id = 763
// module chunks = 0